import {
  NewsletterCreateApiInterface,
  NewsletterId,
  NewsletterType,
} from 'modules/newsletters/single/types/newsletter-interface'
import httpClient from 'shared/utils/http-client'

export const NEWSLETTERS_API = '/api/dashboard/customer/mailing/newsletters'

export const removeNewsletter = (id: NewsletterId) => httpClient.delete(`${NEWSLETTERS_API}/${id}`)

export const createNewsletter = (data: NewsletterCreateApiInterface) =>
  httpClient.post<NewsletterType>(NEWSLETTERS_API, data)

export const duplicateNewsletter = (id: NewsletterId) =>
  httpClient.post<NewsletterType>(`${NEWSLETTERS_API}/duplicate/${id}`)

export const resendNewsletter = (id: NewsletterId, data: any) =>
  httpClient.post<NewsletterType>(`${NEWSLETTERS_API}/resend/${id}`, data)

export const shareNewsletter = (id: NewsletterId) =>
  httpClient.post<string>(`${NEWSLETTERS_API}/share/${id}`)
